module.exports = __webpack_public_path__ + "img/baseline-search-light.c12d1f6d.svg";